// APP CONFIG — Development
export const $themeConfig = {
    locale: 'en',
    theme: 'light',
    menu: 'vertical',
    layout: 'full',
    rtlClass: 'ltr',
    animation: '',
    navbar: 'navbar-sticky',
    semidark: false,
    restRoot: 'https://api-cotacao-cirurgias-dev.azurewebsites.net/api/',
};
